import { formatKabulDisplay } from "./ScheduleFields";
import { LtrIsolate } from "./LtrIsolate";
import {
  auditActionLabel,
  auditActionTone,
  auditSummarySubject,
} from "../lib/audit-ops";
import type { StatusTone } from "../lib/overview-ops";

type ActivityEntry = {
  id: string;
  action: string;
  summary: string;
  createdAt: string;
  actor: { displayName: string } | null;
};

type Props = {
  items: ActivityEntry[];
  loading?: boolean;
  emptyMessage?: string;
};

const TONE_BADGE: Record<StatusTone, string> = {
  success: "state-badge--published",
  warning: "state-badge--paused",
  danger: "state-badge--emergency",
  info: "state-badge--scheduled",
  neutral: "state-badge--archived",
};

export function ActivityFeed({
  items,
  loading,
  emptyMessage = "رویدادی ثبت نشده است.",
}: Props) {
  if (loading) {
    return <p className="card__empty">در حال بارگذاری…</p>;
  }

  if (items.length === 0) {
    return <p className="card__empty">{emptyMessage}</p>;
  }

  return (
    <ul className="activity-list">
      {items.map((entry) => {
        const tone = auditActionTone(entry.action);
        const actor = entry.actor?.displayName ?? "سیستم";
        const subject = auditSummarySubject(entry.summary);

        return (
          <li key={entry.id} className="activity-list-item">
            <div className="activity-list-item__main">
              <span className={`state-badge ${TONE_BADGE[tone]}`}>
                {auditActionLabel(entry.action)}
              </span>
              <span className="activity-list-item__title">{subject}</span>
            </div>
            <div className="activity-list-item__meta">
              <span>{actor}</span>
              <LtrIsolate mono>{formatKabulDisplay(entry.createdAt)}</LtrIsolate>
            </div>
          </li>
        );
      })}
    </ul>
  );
}
